export const PROFILES_TAB_LOADING_MORE = 'profiles-tab.loading-more';
